import { render, staticRenderFns } from "./PickAcademy.vue?vue&type=template&id=29849edf&scoped=true"
import script from "./PickAcademy.vue?vue&type=script&lang=js"
export * from "./PickAcademy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29849edf",
  null
  
)

export default component.exports